var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppceleratorTitanium(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#B01C33;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49,43.3L26.2,3.8C25.9,3.3,25.4,3,24.8,3s-1.2,0.3-1.5,0.8L0.5,43.3c-0.3,0.5-0.3,1.2,0,1.7 c0.3,0.5,0.9,0.8,1.5,0.8h45.6c0.6,0,1.2-0.3,1.5-0.8C49.3,44.5,49.3,43.9,49,43.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.7,34.3c-1.4,1.8-2.9,2.1-4.3,2.1c-1.5,0-3.1-0.5-3.1-2.7c0-2.3,1.5-3,4.4-3h3V34.3L27.7,34.3z M39,36.1 l-5.5-2.4l0.6,1.6l-2.2,0.4V24.7c0-4.8-3.9-5.7-7.2-5.7c-3.6,0-7,0.4-7,0.4v3.3L18,23c0,0,3.3-0.4,6-0.4c2.4,0,3.8,1.1,3.8,3v1.9 h-4.2c-3.8,0-7.5,1.6-7.5,6.5c0,4.8,2.8,6,5.8,6c4,0,5.8-3,5.8-3h0.2l-0.1,2.3l0.3,0.3l6.6-1.2l-0.1,1.7L39,36.1L39,36.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppceleratorTitanium);
export default __webpack_public_path__ + "static/media/appcelerator-titanium.ffec90ecfe1bcba17cc43461c9959937.svg";
export { ForwardRef as ReactComponent };